/**
 * Retrieves an <div> HTMLElement representing a specified tab by its ID.
 * @param tabId The ID of the tab to retrieve.
 */
export function getTabDivElement(tabId: string): HTMLDivElement | null {
	const divElements = document.querySelector(`div[data-tab-id="${tabId}"]`);

	return divElements instanceof HTMLDivElement ? divElements : null;
}

/**
 * Retrieves an <li> HTMLElement representing a specified tab by its ID.
 * @param tabId The ID of the tab to retrieve.
 */
export function getTabLiElement(tabId: string): HTMLLIElement | null {
	const listElements = document.querySelector(`li[data-tab-id="${tabId}"]`);

	return listElements instanceof HTMLLIElement ? listElements : null;
}
